import { Component, Input, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { ESRI } from '../../../../esri-loader-util';
import { LayerService } from '../../../../services/layer.service';
import { IPointStyle } from '../../../../types';
import { BaseSymbolEditorComponent } from '../../symbol-editor/baseSymbolEditor';

let MarkerSymbol: __esri.SimpleMarkerSymbolConstructor;
let PictureSymbol: __esri.PictureMarkerSymbolConstructor;

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-point-symbol-editor-ng',
    templateUrl: './point-symbol-editor.component.html',
    styleUrls: ['../../../sharedStyles/base.scss', './point-symbol-editor.component.scss']
})
export class PointSymbolEditorComponent extends BaseSymbolEditorComponent {

    constructor(_vcr: ViewContainerRef, protected readonly layerService: LayerService) {
        super(_vcr, layerService);
        this.loadESRI();
    }

    private async loadESRI() {
        [MarkerSymbol, PictureSymbol] = await Promise.all([ESRI.SimpleMarker, ESRI.PictureMarker]);
    }

    colorProperties: string[] = ['symbolColor, outlineColor'];
    markerSymbol: __esri.SimpleMarkerSymbol;
    pictureSymbol: __esri.PictureMarkerSymbol;

    pointStyle: IPointStyle;
    pointSize: number;
    pictureUrl: string;
    sizeOptions = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 30, 32, 36, 40, 50, 64, 72, 100, 128];
    // TODO: Implement custom PNG and previews for non-path styles
    pointSymbolOptions = {
        pointStyles: <IPointStyle[]>[
            {
                name: 'Circle',
                type: 'simplemarkersymbol',
                value: 'circle'
            },
            {
                name: 'Square',
                type: 'simplemarkersymbol',
                value: 'square'
            },
            {
                name: 'Cross',
                type: 'simplemarkersymbol',
                value: 'cross'
            },
            {
                name: 'Diamond',
                type: 'simplemarkersymbol',
                value: 'diamond'
            },
            {
                name: 'X',
                type: 'simplemarkersymbol',
                value: 'x'
            },
            {
                name: 'Triangle',
                type: 'simplemarkersymbol',
                value: 'triangle'
            }//,
            //{
            //    name: 'Custom Base64 PNG',
            //    type: 'picturemarkersymbol',
            //    json: {
            //        angle: 0,
            //        xoffset: 0,
            //        yoffset: 0,
            //        type: 'esriPMS',
            //        imageData: '',
            //        contentType: 'image/png',
            //        width: 24,
            //        height: 24
            //    }
            //}
        ]
    };

    bindForm() {
        if (this.layerSymbol) {
            if (this.layerSymbol.type === 'picture-marker') {
                this.pictureSymbol = this.layerSymbol as __esri.PictureMarkerSymbol;
                this.layerService.fixPictureSymbols([this.pictureSymbol]);
                this.pictureUrl = this.pictureSymbol.url;
            } else {
                this.markerSymbol = this.layerSymbol as __esri.SimpleMarkerSymbol;
                if (this.markerSymbol.path) {
                    this.pointStyle = this.pointSymbolOptions.pointStyles.find(style => style.path === this.markerSymbol.path);
                } else {
                    this.pointStyle = this.pointSymbolOptions.pointStyles.find(style => style.value === this.markerSymbol.style);
                }
                this.pointSize = this.markerSymbol.size;
                this.symbolColor = `rgba(${this.markerSymbol.color.toRgba().join(', ')})`;
                this.originalColor = this.symbolColor;
                if (this.markerSymbol.outline) {
                    this.outlineColor = `rgba(${this.markerSymbol.outline.color.toRgba().join(', ')})`;
                    this.originalOutlineColor = this.outlineColor;
                }
            }
        }
    }

    @Input()
    public applyChange = () => {
        if (this.markerSymbol) {
            if (this.markerSymbol.outline) {
                this.markerSymbol.outline.color.setColor(this.outlineColor);
            }
            const markerProperties = {
                angle: this.markerSymbol.angle,
                color: this.symbolColor,
                outline: this.markerSymbol.outline.clone(),
                size: this.pointSize,
                style: this.pointStyle.value,
                xoffset: this.markerSymbol.xoffset,
                yoffset: this.markerSymbol.yoffset
            } as __esri.SimpleMarkerSymbolProperties;
            if (this.pointStyle.path) {
                markerProperties.path = this.pointStyle.path;
            }
            this.layerSymbol = new MarkerSymbol(markerProperties);
        } else if (this.pictureSymbol) {
            this.layerSymbol = new PictureSymbol({
                angle: this.pictureSymbol.angle,
                color: this.pictureSymbol.color.clone(),
                height: this.pictureSymbol.height,
                url: this.pictureUrl,
                width: this.pictureSymbol.width,
                xoffset: this.pictureSymbol.xoffset,
                yoffset: this.pictureSymbol.yoffset
            });
        }
        window.dispatchEvent(new CustomEvent<string>('symbolChange', { detail: this.uniqueLayerId }));
        return this.layerSymbol;
    }
}
